/**
 * Maps bare i18next language codes to the BCP-47 locale that should be used
 * for date/time formatting. Add entries here whenever the app's language key
 * differs from the desired Intl locale (e.g. "en" ships DD/MM/YYYY via en-GB).
 */
const LOCALE_MAP: Record<string, string> = {
	en: "en-GB",
};

export const formatDate = (timestamp: number, t: (key: string) => string, locale?: string) => {
	const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
	const rawLocale = locale ?? Intl.DateTimeFormat().resolvedOptions().locale;
	const resolvedLocale = LOCALE_MAP[rawLocale] ?? rawLocale;

	const date = new Date(timestamp);
	const now = new Date();

	const isToday =
		date.getDate() === now.getDate() &&
		date.getMonth() === now.getMonth() &&
		date.getFullYear() === now.getFullYear();

	const yesterday = new Date(now);

	yesterday.setDate(now.getDate() - 1);
	const isYesterday =
		date.getDate() === yesterday.getDate() &&
		date.getMonth() === yesterday.getMonth() &&
		date.getFullYear() === yesterday.getFullYear();

	const timeStr = new Intl.DateTimeFormat(resolvedLocale, {
		hour: "2-digit",
		minute: "2-digit",
		timeZone: userTimezone,
	}).format(date);

	if (isToday) {
		return timeStr;
	}

	if (isYesterday) {
		return `${t("yesterday")}, ${timeStr}`;
	}

	const dateStr = new Intl.DateTimeFormat(resolvedLocale, {
		day: "2-digit",
		month: "2-digit",
		year: "numeric",
		timeZone: userTimezone,
	}).format(date);

	return `${dateStr}, ${timeStr}`;
};
